import { useEffect } from 'react';
import { Box } from '@mui/material';
import NProgress from 'nprogress';

function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        left: '0',
        position: 'fixed',
        top: '0',
        width: '100%',
        zIndex: '10000'
      }}
     />
  );
}

export default SuspenseLoader;
